import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from './config';

import { formatDate } from '@angular/common';


@Injectable()
export class SharedDateService {
    commonUrl: string = CONFIG.baseUrls.common.replace(CONFIG.Urls.apiUrlOld, CONFIG.Urls.apiUrlNew);
    SelectedAllServices = [];
    constructor(private _http: HttpClient) {
    }

    todayFromServer: Date;

    // observable for common controller
    day$ = this._http.get(`${this.commonUrl}/Today/`).pipe(map(res => res));

    /**
     * subscribe for day$ observable
     */
    subscribe() {
        this.day$.subscribe((day: Date) => {
            this.todayFromServer = day;
        }, err => console.log('from shared date call server fun', err)
            , () => {
                return this.convertFromDateToNgBsObject(this.todayFromServer);
            });
    }

    getTodayFromServer() {
        return this.subscribe();
    }
    get getCurrentDate() {
        const date = new Date();
        const format = 'yyyy-MM-dd HH:mm';
        const locale = 'en-US';
        return formatDate(date, format, locale);
    }
    /*************************************************************
     * used to get date object from ng bootstrap datepicker object
     * @param oldDate
     */
    convertFromNgBsToDate(oldDate: any) {
        if (!oldDate || !oldDate.year || oldDate.year == undefined || oldDate.year == null)
            return oldDate;
        return new Date(oldDate.year, oldDate.month - 1, oldDate.day);
    }
    dateFromAge(_years, _months, _days) {

        var date = new Date();
        date.setDate(date.getDate() - _days);
        date.setMonth(date.getMonth() - _months);
        date.setFullYear(date.getFullYear() - _years);
        return date;

    }



    //////////convert from bs to date
    ///////
    convertFromBsToDateTime(time: any, acceptZeroTime: boolean = false) {
        let date = new Date();
        date.setHours(time.hour, time.minute);
        if (acceptZeroTime) {
            date["AcceptZeroTime"] = 1;
            date["AcceptZeroTime"] = 1;
        }
        return (date);
    }

    convertFromBsToDateTimeObj(time: any) {

        let date = new Date(time);
        if (date && time) {

            return {
                hour: date.getHours(),
                minute: date.getMinutes(),
            };
        }
        else {
            return;
        }
    }
    /**************************************************************
     * used to get ng bootstrap datepicker object  from date object
     * take date object in string format or date format
     * @param oldDate
     */
    convertFromDateToNgBsObject(oldDate: any) {
        return getNgBsObj(oldDate);
    }

    // saveClickEvent = new EventEmitter();
    // saveSub: Subscription;

    // emitSaveClick() {
    //     this.saveClickEvent.emit();
    // }

    fromBooleanToNumber(data: any) {

        ////////////////////////////////////////////amer hashima////////////////////////////////////////////////
        for (let [key, value] of Object.entries(data)) {

            if (value == true) {
                data[key] = 1
            } else if (value === false && value != null) {
                data[key] = 0

            }
        }

    }
}


/*************************************************************
     * used to get date object from ng bootstrap datepicker object
     * @param oldDate
     */
export function getDateObj(oldDate: any, time?: any): any {
    let _datetime: Date = null;
    if (!oldDate || !oldDate.year || oldDate.year == undefined || oldDate.year == null)
        return oldDate;


    _datetime = new Date(oldDate.year, oldDate.month - 1, oldDate.day);
    if (time && (time['hour'] || time['minute'])) {
        _datetime.setHours(time['hour'], time['minute']);
    }
    return _datetime;
}

export function getNgbTime(time: any): any {
    let date = new Date(time);
    if (date && time) {
        return {
            hour: date.getHours(),
            minute: date.getMinutes(),
            hourMinute: date.toTimeString().split(':').slice(0, 2).join(':')//amer11102022
        };
    }
    else {
        return;
    }
}

/**************************************************************
     * used to get ng bootstrap datepicker object  from date object
     * take date object in string format or date format
     * @param oldDate
     */
export function getNgBsObj(oldDate: any): any {

    let dateObj = new Date(oldDate);
    if (dateObj && oldDate) {
        let dateStr = dateObj.toJSON();
        const year = dateStr.substr(0, 4)
        const month = dateStr.substr(5, 2)
        const day = dateStr.substr(8, 2);
        if (isNumber(year) && isNumber(month) && isNumber(day)) {
            return {
                year: +year,
                month: +month,
                day: +day,
            };
        }
        else {
            return null;
        }

    }
}

export function isToday(date): boolean {
    const _date = new Date(date);
    const today = new Date();
    return _date.getDate() == today.getDate() &&
        _date.getMonth() == today.getMonth() &&
        _date.getFullYear() == today.getFullYear()
}


export function isNumber(value: any): value is number {
    return !isNaN(toInteger(value));
}
export function toInteger(value: any): number {
    return parseInt(`${value}`, 10);
}

export function calculateBmi(height: number, weight: number): any {
    height = height / 100; // height in cm
    let Bmi = (weight / (height ** 2)).toFixed(3);
    return Bmi;
}



export function GenerateMedDoseDesc({ dosTypeAr, name, doseQty, dosTypeEn, freqQty, periodQty, routeAdminAr, routeAdminEn, freqType,
    periodType, routeAdminCode, rxNotes, isActiveMaterial, strengthValueConcName, identifierAr, identifierEn, onlyOnceTime, ivDoseQty, ivDoseTiming, ivItemAr,
    ivItemEn, compeleteTo, forTime, ivDripRate }, type: 'ar' | 'en', RxType?: number, items?: any[]): { ar: string, en: string } {
    var t = '';//name;
    var e = doseQty;
    var x = type == 'ar' ? dosTypeAr : dosTypeEn;
    var s = periodQty;
    var y = type == 'ar' ? routeAdminAr : routeAdminEn;
    var freqQty = freqQty > 0 ? freqQty : 0;
    var identifierAr = identifierAr;
    var identifierEn = identifierEn;
    var isActiveMaterial = isActiveMaterial;
    var xEn = '';
    var xAr = '';
    var freqName: { ar?: string, en?: string } = { ar: '', en: '' };
    var freqNames: { ar?: string, en?: string } = { ar: '', en: '' };
    var forTimeAr = '';
    var forTimeEn = '';
    if (freqType == 3) {
        // freqQty = freqQty * 1;
        freqName = {
            ar: 'يوم',
            en: 'Day'
        };
        freqNames = {
            ar: 'أيام',
            en: 'Days'
        };
    }
    if (freqType == 4) {
        // freqQty = freqQty * 7;
        freqName = {
            ar: 'اسبوع',
            en: 'Week'
        };
        freqNames = {
            ar: 'أسابيع',
            en: 'Weeks'
        };
    }
    if (freqType == 5) {
        // freqQty = freqQty * 30;
        freqName = {
            ar: 'شهر',
            en: 'Month'
        }
        freqNames = {
            ar: 'شهور',
            en: 'Months'
        };
    }
    var periodQtyd = periodQty > 0 ? periodQty : 0;
    var periodName: { ar?: string, en?: string } = { ar: '', en: '' };
    var periodNames: { ar?: string, en?: string } = { ar: '', en: '' };
    if (periodType == 3) {
        // periodQtyd = periodQty * 1;
        periodName = {
            ar: 'يوم',
            en: 'Day'
        };
        periodNames = {
            ar: 'أيام',
            en: 'Days'
        };
    }
    if (periodType == 4) {
        // periodQtyd = periodQty * 7;
        periodName.ar = 'اسبوع';
        periodName.en = 'Week';
        periodNames = {
            ar: 'أسابيع',
            en: 'Weeks'
        };
    }
    if (periodType == 5) {
        // periodQtyd = periodQty * 30;
        periodName = {
            ar: 'شهر',
            en: 'Month'
        };
        periodNames = {
            ar: 'شهور',
            en: 'Months'
        };
    }
    if (isActiveMaterial == 1) {
        xEn = '';
        xAr = '';
        rxNotes = strengthValueConcName;
    }
    else {
        xEn = 'By ';
        xAr = 'ب';
    }
    if (forTime > 0) {
        forTime == 1 ? forTimeAr = ' 5 م 5 / ص  ' : forTime == 2 ? forTimeAr = ' 11 م 11 / ص  ' : forTimeAr = ''
        forTime == 1 ? forTimeEn = '5 AM / 5 PM ' : forTime == 2 ? forTimeEn = '11 AM / 11 PM' : forTimeEn = ''
    }
    console.log("activematerial:" + isActiveMaterial + "xEn:" + xEn + "xAr:" + xAr);
    if (RxType == 2 && x != '') {
        return {
            ar:
                `${t} ${e} ${dosTypeAr}   ${routeAdminCode ? xAr + y : ''}
                   ${onlyOnceTime} لمرة واحدة فقط الساعة  ${rxNotes ? '_' + rxNotes : ''}`,
            en: `${t} ${e} ${dosTypeEn}     ${routeAdminCode ? xEn + y : ''}
              only once At  ${onlyOnceTime}         ${rxNotes ? rxNotes : ''}`
        };
    } if (RxType == 3 && x != '') {
        return {
            ar:
                `${t} ${e} ${dosTypeAr}   ${routeAdminCode ? xAr + y : ''}
                عند اللزوم ${rxNotes ? '_' + rxNotes : ''}`,
            en: `${t} ${e} ${dosTypeEn}    ${routeAdminCode ? xEn + y : ''}
             As Required ${rxNotes ? rxNotes : ''}`
        };

    } if (RxType == 4 && x != '') {
        var ivMixItemAr = '';
        var ivMixItemEn = '';
        if (items && items.length > 0) {
            ivDoseQty = items.reduce((sum, el) => sum + parseFloat(el.ivDoseQty), 0);
            ivDoseTiming = items.reduce((sum, el) => sum + parseFloat(el.ivDoseTiming), 0);
            const mainItem = items[0];
            ivMixItemAr = `${mainItem.nameAr} `;
            ivMixItemEn = `${mainItem.nameEn} `;
            if (items.length > 0) {
                const extrasAr = items.map(el => `${el.ivNameAr} ${el.ivDoseQty} مل`).join(', ');
                const extrasEn = items.map(el => `${el.ivNameEn} ${el.ivDoseQty} ML `).join(', ');
                ivMixItemAr += ' مع ' + extrasAr;
                ivMixItemEn += ' with ' + extrasEn;
            }
        }
        return {
            ar:
                `${ivMixItemAr} ${identifierAr ? 'لكل ' + identifierAr : ''} كل ${periodQtyd} ${periodNames.ar}  ${routeAdminCode ? xAr + y : ''}
                ${freqQty ? 'لمدة ' + freqQty + ' ' + freqName.ar : ''}  يحل في  ${ivDoseQty}   مل جرام لمدة  ${ivDoseTiming} دقيفة بمعدل ${ivDripRate}  مل/د ${rxNotes ? '_' + rxNotes : ''}`,

            en: `${ivMixItemEn}  ${identifierAr ? 'For Every ' + identifierEn : ''} Every ${s} Hours  ${routeAdminCode ? xEn + y : ''}
            ${freqQty ? 'For ' + freqQty + ' ' + freqName.en : ''} Solution In  ${ivDoseQty} ML  For   ${ivDoseTiming} Min With Rate ${ivDripRate}  ml/min ${rxNotes ? rxNotes : ''}`
        };
    } else {
        if (s == 1 || s == 2)
            return {
                ar: (periodType > 2 ?
                    `${t} ${e} ${dosTypeAr}   ${identifierAr ? 'لكل ' + identifierAr : ''}  كل   ${periodQtyd} ${periodName.ar}  ${freqQty ? 'لمدة ' + freqQty + ' ' + freqName.ar : ''}
                    ${compeleteTo > 0 && !isActiveMaterial ? ' مكمل ب ' + compeleteTo + ' مل' : ' '}
                    ${forTime > 0 && !isActiveMaterial ? ' في ' + forTimeAr : ' '}
                 ${rxNotes ? '_' + rxNotes : ''}` :
                    `${t} ${e} ${dosTypeAr}   ${identifierAr ? 'لكل ' + identifierAr : ''}  كل ${s} ساعة   ${freqQty ? 'لمدة ' + freqQty + ' ' + freqName.ar : ''}
                    ${compeleteTo > 0 && !isActiveMaterial ? ' مكمل ب ' + compeleteTo + ' مل' : ' '} 
                     ${forTime > 0 && !isActiveMaterial ? ' في ' + forTimeAr : ' '}
                     ${rxNotes ? '_' + rxNotes : ''}`).replace(/\s+/g, ' ').trim(),

                en: (periodType > 2 ?
                    `${t} ${e} ${dosTypeEn} ${identifierAr ? 'For Every ' + identifierEn : ''}  Every ${periodQtyd} ${periodName.en}   ${freqQty ? 'For ' + freqQty + ' ' + freqName.en : ''}${compeleteTo > 0 && !isActiveMaterial ? ' complete To ' + compeleteTo + ' ml' : ' '}
                 ${rxNotes ? '_' + rxNotes : ''}` :
                    `${t} ${e} ${dosTypeEn} ${identifierAr ? 'For Every ' + identifierEn : ''} Every ${s} Hour    ${freqQty ? 'For ' + freqQty + ' ' + freqName.en : ''}
                    ${compeleteTo > 0 && !isActiveMaterial ? ' complete To ' + compeleteTo + ' ML' : ' '}
                     ${forTime > 0 && !isActiveMaterial ? ' AT ' + forTimeEn : ' '}
                      ${rxNotes ? '_' + rxNotes : ''}`).replace(/\s+/g, ' ').trim()
            };

        if (s > 2)
            return {
                ar: (periodType > 2 ?
                    `${t} ${e} ${dosTypeAr}  ${identifierAr ? 'لكل ' + identifierAr : ''} كل ${periodQtyd} ${periodNames.ar} ${routeAdminCode ? xAr + y : ''} ${freqQty ? 'لمدة ' + freqQty + ' ' + freqName.ar : ''}
                    ${compeleteTo > 0 && !isActiveMaterial ? ' مكمل ب ' + compeleteTo + '  مل' : ' '}
                    ${forTime > 0 && !isActiveMaterial ? ' AT ' + forTimeAr : ' '} 
                    ${rxNotes ? '_' + rxNotes : ''}` :
                    `${t} ${e} ${dosTypeAr}  ${identifierAr ? 'لكل ' + identifierAr : ''} كل ${s} ساعات ${routeAdminCode ? xAr + y : ''} ${freqQty ? 'لمدة ' + freqQty + ' ' + freqName.ar : ''}
                    ${compeleteTo > 0 && !isActiveMaterial ? ' مكمل ب ' + compeleteTo + '  مل' : ' '}
                    ${forTime > 0 && !isActiveMaterial ? ' AT ' + forTimeAr : ' '} 
                    ${rxNotes ? '_' + rxNotes : ''}`).replace(/\s+/g, ' ').trim(),
                en: (periodType > 2 ?
                    `${t} ${e} ${dosTypeEn} ${identifierAr ? 'For Every ' + identifierEn : ''} Every ${periodQtyd} ${periodNames.en}   ${routeAdminCode ? xEn + y : ''}
                     ${freqQty ? 'For ' + freqQty + ' ' + freqName.en : ''}
                     ${compeleteTo > 0 && !isActiveMaterial ? ' complete To ' + compeleteTo + '  ml' : ' '}  
                     ${forTime > 0 && !isActiveMaterial ? ' AT ' + forTimeEn : ' '}  ${rxNotes ? rxNotes : ''}` :
                    `${t} ${e} ${dosTypeEn} ${identifierAr ? 'For Every ' + identifierEn : ''} Every ${s} Hours  ${routeAdminCode ? xEn + y : ''} ${freqQty ? 'For ' + freqQty + ' ' + freqName.en : ''}
                     ${compeleteTo > 0 && !isActiveMaterial ? ' complete To ' + compeleteTo + '  ml' : ' '}
                     ${forTime > 0 && !isActiveMaterial ? ' AT ' + forTimeEn : ' '} ${rxNotes ? '_' + rxNotes : ''}`).replace(/\s+/g, ' ').trim()
            };
        if (!s) {
            return {
                ar: '',
                en: ''
            }
        }

    }


}
